/* eslint-disable no-control-regex */
// import store from "../store";
export const monthName = [
  "Januari",
  "Februari",
  "Maret",
  "April",
  "Mei",
  "Juni",
  "Juli",
  "Agustus",
  "September",
  "Oktober",
  "November",
  "Desember",
];
export let doubleDigit = function(value) {
  let stringValue = String(value);
  if (value < 10) {
    stringValue = "0" + stringValue;
  }
  return stringValue;
};
export let getTime = function(hour, minute) {
  return doubleDigit(hour) + ":" + doubleDigit(minute);
};
export let getTimeWithSecond = function(hour, minute, second) {
  return (
    doubleDigit(hour) + ":" + doubleDigit(minute) + ":" + doubleDigit(second)
  );
};
export let jenKelamin = {
  L: "Laki-laki",
  P: "Perempuan",
};

export const posPtgOptions = [
  { label: "Perawat", value: "rawat" },
  { label: "Petugas Apotik", value: "apotik" },
  { label: "Petugas Optik", value: "optik" },
  { label: "Perawat Operasi", value: "operasi" },
  { label: "Petugas Lab", value: "lab" },
  { label: "Administrasi", value: "adm" },
  { label: "Kasir", value: "kasir" },
];

export const tipeDiskonOptions = [
  { label: "Rp", value: "Rp" },
  { label: "Persen", value: "Percentage" },
];
export const getPosisi = (value) => {
  let found = posPtgOptions.find((item) => {
    return item.value == value;
  });
  return found ? found.label : "";
};
export let pj = {
  "1": "Ayah",
  "2": "Ibu",
  "3": "Istri",
  "4": "Suami",
  "5": "Saudara",
  "6": "Anak",
};

export let agama = {
  "1": "Islam",
  "2": "Kristen Protestan",
  "3": "Kristen Katholik",
  "4": "Hindu",
  "5": "Buddha",
  "6": "Konghuchu",
};

let resiko = [
  "Rendah",
  "Rendah",
  "Rendah",
  "Rendah",
  "Sedang",
  "Sedang",
  "Sedang",
  "Sedang",
  "Tinggi",
  "Tinggi",
  "Tinggi",
];
export let convertToRupiah = function(money) {
  var rupiah = "";
  if (money) {
    var angkarev = money
      .toString()
      .split("")
      .reverse()
      .join("");
    for (var i = 0; i < angkarev.length; i++)
      if (i % 3 == 0) rupiah += angkarev.substr(i, 3) + ".";
    return (
      "Rp " +
      rupiah
        .split("", rupiah.length - 1)
        .reverse()
        .join("")
    );
  } else {
    return "Rp 0";
  }
};
export let convertToMoney = function(money) {
  var rupiah = "";
  if (money) {
    var angkarev = money
      .toString()
      .split("")
      .reverse()
      .join("");
    for (var i = 0; i < angkarev.length; i++)
      if (i % 3 == 0) rupiah += angkarev.substr(i, 3) + ".";
    return rupiah
      .split("", rupiah.length - 1)
      .reverse()
      .join("");
  } else {
    return "0";
  }
};
export let revertToNumber = function(formatted) {
  // Rp 330.792
  return parseInt(
    formatted
      .replace("Rp", "")
      .replace(" ", "")
      .replace(/./g, "")
  );
};

export let setBayarIntro = function(ralan) {
  let intro = {
    picture: `${ralan.pasien.formatted_foto || "/img/user.jpg"}`,
    topSubtitle: "",
    title: ralan.pasien.nama,
    subtitle: `No RM : ${ralan.pasien.no_rm} | Pasien Peserta ${ralan.pasien.asuransi.nama}`,
    items: [
      {
        icon: "wc",
        content: ralan.pasien.jen_kelamin,
      },
      { icon: "phone", content: ralan.pasien.no_telp },
    ],
    topRight: [
      {
        key: 1,
        columns: [
          {
            colnum: 5,
            icon: "",
            label: "NO RAWAT",
            content: ralan.no_rawat,
          },
          {
            colnum: 7,
            icon: "",
            label: "DOKTER",
            content: ralan.dokter.formatted_nama,
          },
        ],
      },
      {
        key: 1,
        columns: [
          {
            colnum: 12,
            icon: "",
            label: "UNIT",
            content: ralan.unit?.formatted_unit,
          },
        ],
      },
    ],
  };

  return intro;
};
export let setOperationIntro = function(ralan, operasi) {
  //console.log(ralan);
  //console.log(operasi);
  let introRalan = {
    picture: `${ralan.pasien.formatted_foto || "/img/user.jpg"}`,
    topSubtitle: "",
    title: ralan.pasien.nama,
    subtitle: `No RM : ${ralan.pasien.no_rm} | Pasien Peserta ${ralan.pasien.asuransi.nama}`,
    items: [
      {
        icon: "wc",
        content: ralan.pasien.jen_kelamin,
      },
      { icon: "phone", content: ralan.pasien.no_telp },
    ],
    topRight: [
      {
        key: 1,
        columns: [
          {
            colnum: 5,
            icon: "today",
            label: "TANGGAL LAHIR",
            content: ralan.pasien.formatted_tgl_lahir_umur,
          },
          {
            colnum: 7,
            icon: "tag",
            label: "NO RAWAT",
            content: `${ralan.no_rawat}`,
          },
        ],
      },
      {
        key: 1,
        columns: [
          {
            colnum: 5,
            icon: "wb_sunny",
            label: "AGAMA",
            content: ralan.pasien.agama,
          },
          {
            colnum: 7,
            icon: "person",
            label: "PENANGGUNG JAWAB",
            content: ralan.pasien.formatted_pj,
          },
        ],
      },
    ],
  };

  let introOperasi = [
    {
      key: String(Math.random(1023)),
      columns: [
        {
          label: "Jadwal Operasi",
          content: operasi.tanggal + " " + operasi.sign_in,
          icon: "apps",
          colwidth: 3,
        },
        {
          label: "Dokter Operator",
          content: operasi.dokter_operator
            ? operasi.dokter_operator.formatted_nama
            : "",
          icon: "person_pin",
          colwidth: 3,
        },
        {
          label: "Nama Operasi",
          content: operasi.nama_operasi,
          icon: "apps",
          colwidth: 3,
        },
        {
          label: "Persetujuan",
          content: operasi.formatted_file_persetujuan,
          icon: "apps",
          colwidth: 3,
          type: "file",
        },
      ],
    },
  ];

  return { introRalan, introOperasi };
};
export let setPatientIntro = function(patient) {
  let intro = {
    link: `/pasien/detail/${patient.id}`,
    picture: `${patient.formatted_foto || "/img/user.jpg"}`,
    topSubtitle: "",
    title: patient.nama,
    subtitle: `No RM : ${patient.no_rm} | Pasien Peserta ${patient.asuransi.nama}`,
    items: [
      {
        icon: "wc",
        content: patient.jen_kelamin,
      },
      { icon: "phone", content: patient.no_telp },
    ],
    topRight: [
      {
        key: 1,
        columns: [
          {
            colnum: 5,
            icon: "today",
            label: "TANGGAL LAHIR",
            content: patient.formatted_tgl_lahir_umur,
          },
          {
            colnum: 7,
            icon: "",
            label: "PENANGGUNG JAWAB",
            content: `${patient.formatted_pj}`,
          },
        ],
      },
      {
        key: 1,
        columns: [
          {
            colnum: 5,
            icon: "wb_sunny",
            label: "AGAMA",
            content: patient.agama,
          },
          {
            colnum: 7,
            icon: "place",
            label: "",
            content: patient.formatted_alamat
              ? patient.formatted_alamat
              : patient.alamat,
          },
        ],
      },
    ],
  };

  return intro;
};

export let setKartuPasien = function(patient) {
  let intro = {
    link: `/pasien/detail/${patient.id}`,
    picture: `${patient.formatted_foto || "/img/user.jpg"}`,
    topSubtitle: `No RM : ${patient.no_rm}`,
    no_rm: patient.no_rm,
    title: patient.nama,
    subtitle: `Pasien ${patient.asuransi.nama}`,
    items: [
      {
        icon: "wc",
        content: patient.jen_kelamin,
      },
      { icon: "phone", content: patient.no_telp },
    ],
    topRight: [
      {
        key: 1,
        columns: [
          {
            colnum: 5,
            icon: "today",
            label: "TANGGAL LAHIR",
            content: patient.formatted_tgl_lahir_umur,
          },
          {
            colnum: 7,
            icon: "",
            label: "PENANGGUNG JAWAB",
            content: `${patient.formatted_pj}`,
          },
        ],
      },
      {
        key: 1,
        columns: [
          {
            colnum: 5,
            icon: "wb_sunny",
            label: "AGAMA",
            content: patient.agama,
          },
          {
            colnum: 7,
            icon: "place",
            label: "",
            content: patient.alamat,
          },
        ],
      },
    ],
  };

  return intro;
};

export let setRawatIntro = function(ralan) {
  let detailLeftTop = [
    {
      key: String(Math.random(1023)),
      columns: [
        {
          label: "No. Rawat",
          content: ralan.no_rawat,
          icon: "confirmation_number",
          colwidth: 4,
        },
        {
          label: "Unit",
          content: ralan.unit ? ralan.unit.formatted_unit : "-",
          icon: "apps",
          colwidth: 8,
        },
      ],
    },
  ];
  let detailRightTop = [
    {
      label: "Dokter yang Dituju",
      content: ralan.dokter ? ralan.dokter.formatted_nama : "-",
      icon: "person_pin",
    },
  ];
  //console.log(ralan.dokter)

  return { detailLeftTop, detailRightTop };
};

export let slashToDash = function(str) {
  return str.replace(/\//g, "-");
};
export let dashToSlash = function(str) {
  return str.replace(/-/g, "/");
};
export let isEmpty = function(map) {
  for (var key in map) {
    return false;
  }
  return true;
};
export let setPeriksaPetugas = function(data, storageUrl) {
  //console.log(data);
  return {
    left: [
      {
        key: String(Math.random(1023)),
        colnum: 2,
        columns: [
          {
            label: "Tanggal/Waktu Periksa",
            content: data.formatted_tgl_jam_periksa,
            icon: "access_time",
          },
          {
            label: "Perawat Pemeriksa",
            content: data.formatted_petugas,
            icon: "person_outline",
          },
        ],
      },
      {
        key: String(Math.random(1023)),
        colnum: 2,
        columns: [{ label: "tanda vital", labelClass: "text-primary" }],
      },
      {
        key: String(Math.random(1023)),
        colnum: 3,
        columns: [
          { label: "suhu badan", content: data.suhu + " °C", icon: "apps" },
          {
            label: "tekanan darah",
            content: data.tkn_darah + " mmHg",
            icon: "apps",
          },
        ],
      },
      {
        key: String(Math.random(1023)),
        colnum: 3,
        columns: [
          { label: "nadi", content: data.nadi + " x/menit", icon: "apps" },
          {
            label: "respirasi",
            content: data.respirasi + " x/menit",
            icon: "apps",
          },
          { label: "gdse", content: data.gdse + " mg/dL", icon: "apps" },
        ],
      },
      {
        key: String(Math.random(1023)),
        colnum: 2,
        columns: [{ label: "skrining gizi", labelClass: "text-primary" }],
      },
      {
        key: String(Math.random(1023)),
        colnum: 3,
        columns: [
          { label: "berat badan", content: data.berat + " kg", icon: "apps" },
          { label: "tinggi badan", content: data.tinggi + " cm", icon: "apps" },
        ],
      },
      {
        key: String(Math.random(1023)),
        colnum: 2,
        columns: [{ label: "fungsional", labelClass: "text-primary" }],
      },
      {
        key: String(Math.random(1023)),
        colnum: 1,
        columns: [
          {
            label: "alat bantu",
            content: data.alat_bantu,
            icon: "apps",
          },
        ],
      },
      {
        key: String(Math.random(1023)),
        colnum: 1,
        columns: [
          {
            label: "prothesa",
            content: data.prothesa,
            icon: "apps",
          },
        ],
      },
      {
        key: String(Math.random(1023)),
        colnum: 1,
        columns: [
          {
            label: "cacat tubuh",
            content: data.cct_tubuh,
            icon: "apps",
          },
        ],
      },
      {
        key: String(Math.random(1023)),
        colnum: 1,
        columns: [{ label: "ADL", content: data.adl, icon: "apps" }],
      },
      {
        key: String(Math.random(1023)),
        colnum: 1,
        columns: [{ label: "RPD", content: data.rpd, icon: "apps" }],
      },
      {
        key: String(Math.random(1023)),
        colnum: 1,
        columns: [{ label: "STATUS ALERGI", labelClass: "text-primary" }],
      },
      {
        key: String(Math.random(1023)),
        colnum: 2,
        columns: [
          { label: "Obat / Alkes", content: data.alg_obat, icon: "apps" },
          {
            label: "Makanan",
            content: data.alg_makanan,
            icon: "apps",
          },
        ],
      },
    ],
    right: [
      {
        label: "SKRINING RESIKO JATUH DAN CEDERA",
        labelClass: "text-primary",
      },
      {
        label:
          "a. Cara jalan pasien saat akan duduk di kursi  tampak tidak seimbang (sempoyongan/limbung)",
        content: data.formatted_rsk_a,
        icon: "",
        labelClass: "text-lowercase text-info",
      },
      {
        label:
          "b. Pasien memegang pinggiran kursi/meja/benda lain saat akan duduk",
        content: data.formatted_rsk_b,
        icon: "",
        labelClass: "text-lowercase text-info",
      },
      {
        label: "Hasil",
        content: data.formatted_tkt_resiko,
        icon: "apps",
      },
      {
        label: "Skala Nyeri",
        content:
          data.skala_nyeri +
          " dari 10 (Nyeri " +
          resiko[parseInt(data.skala_nyeri)] +
          ")",
        icon: "apps",
      },
      {
        label: "Keluhan Pasien",
        content: data.keluhan,
        icon: "apps",
      },
      {
        label: "SOAP Perawat",
        content: data.soap,
        icon: "apps",
      },
      {
        label: "Persetujuan Tindakan Kedokteran",
        type: "file",
        content: getFullUrl(storageUrl, data.file_persetujuan),
        icon: "file_download",
      },
      {
        label: "Penandaan Operasi",
        type: "file",
        content: getFullUrl(storageUrl, data.file_penandaan_operasi),
        icon: "file_download",
      },
      {
        label: "Serah Terima Pasien",
        type: "file",
        content: getFullUrl(storageUrl, data.file_serah_terima),
        icon: "file_download",
      },
    ],
  };
};

export let setPeriksaDokter = function(data) {
  //console.log(data);
  let medical = [];
  if (data.rln_periksa_dok_penyakit && data.rln_periksa_dok_penyakit.length) {
    medical = [
      {
        label: "Diagnosa",
        content: data.rln_periksa_dok_penyakit
          .map((item) => {
            return `${item.penyakit.tipe} ${item.penyakit.kode}${
              item.penyakit.subkode ? `.${item.penyakit.subkode}` : ""
            } - ${item.penyakit.desc_short} `;
          })
          .join(", "),
      },
    ];
  }
  return {
    left: [
      {
        label: "Tanggal/Waktu Periksa",
        content: data.formatted_tgl_jam_periksa,
        icon: "access_time",
      },
      {
        label: "Pemeriksaan Fisik",
        content: data.formatted_fisik,
        type: "image",
      },
      ...medical,
    ],
    right: [
      { label: "Dx Utama", content: data.dx_utama },
      { label: "Dx Sekunder", content: data.dx_sekunder },
      { label: "Penatalaksanaan Medis", content: data.medis },
      ...(data.soap ? [{ label: "SOAP Dokter", content: data.soap }] : []),
    ],
  };
};

export let setPeriksaOphthalmic = function(data, storageUrl) {
  //console.log(storageUrl);
  return [
    {
      key: String(Math.random(1023)),
      columns: [
        {
          label: "Tanggal/Waktu Periksa",
          content: data.formatted_tgl_jam_periksa,
          icon: "access_time",
          colwidth: 3,
        },
        {
          label: "Perawat Pemeriksa 1",
          content: data.formatted_petugas,
          icon: "person_outline",
          colwidth: 3,
        },
        ...(data.formatted_petugas_2
          ? [
              {
                label: "Perawat Pemeriksa 2",
                content: data.formatted_petugas_2,
                icon: "person_outline",
                colwidth: 3,
              },
            ]
          : []),
      ],
    },
    {
      key: String(Math.random(1023)),
      columns: [
        { label: "Keluhan Pasien", content: data.keluhan, colwidth: 12 },
      ],
    },
    {
      key: String(Math.random(1023)),
      colnum: 2,
      columns: [
        ...(data.foto_usg && data.foto_usg.length
          ? [
              {
                label: "Hasil USG",
                content: getFullUrl(
                  storageUrl,
                  data.foto_usg[data.foto_usg.length - 1].foto
                ),
                type: "image",
              },
            ]
          : []),
        ...(data.foto_iol_master && data.foto_iol_master.length
          ? [
              {
                label: "Hasil IOL Master",
                content: getFileName(
                  data.foto_iol_master[data.foto_iol_master.length - 1].foto
                ),
                actionBtn: [
                  {
                    class: "btn-outline-secondary  btn-with-icon-left btn-sm",
                    label: "Download",
                    link: getFullUrl(
                      storageUrl,
                      data.foto_iol_master[data.foto_iol_master.length - 1].foto
                    ),
                    target: "_download",
                    iconLeft: "cloud_download",
                  },
                ],
              },
            ]
          : []),
      ],
    },
    {
      key: String(Math.random(1023)),
      colnum: 2,
      columns: [
        ...(data.foto_fundus
          ? [
              {
                label: "Foto Fundus",
                content: getFullUrl(storageUrl, data.foto_fundus),
                type: "image",
              },
            ]
          : []),
        ...(data.soap ? [{ label: "SOAP Perawat", content: data.soap }] : []),
      ],
    },
  ];
};
export let ageInterval = [
  "< 4 Tahun",
  "1-4 Tahun",
  "5-14 Tahun",
  "15-44 Tahun",
  "45-64 Tahun",
  ">65 Tahun",
];
export let labelValueFormatter = function(arr, labelWidth = 150) {
  return arr.map(function(item) {
    return {
      style: "labelValue",
      columns: [
        { text: item.label, width: labelWidth },
        { text: ":", width: 2 },
        { text: item.value },
      ],
    };
  });
};

export let discounted = function(amount, tipe_diskon, diskon) {
  if (diskon) {
    switch (tipe_diskon) {
      case "PERCENTAGE":
        if (diskon > 100) {
          return 0;
        } else if (diskon < 0) {
          return amount;
        } else {
          return Math.ceil(amount - (diskon * amount) / 100);
        }
      case "FIXED":
        if (diskon > amount) {
          return 0;
        } else if (diskon < 0) {
          return amount;
        } else {
          return amount - diskon;
        }
      default:
        if (diskon > amount) {
          return 0;
        } else if (diskon < 0) {
          return amount;
        } else {
          return amount - diskon;
        }
    }
  }
  return amount;
};

export const formatDiscount = function(tipe_diskon, diskon) {
  if (tipe_diskon && diskon) {
    switch (tipe_diskon) {
      case "FIXED":
        return convertToRupiah(diskon);
      case "PERCENTAGE":
        return diskon + "%";
      default:
        return convertToRupiah(diskon);
    }
  } else {
    return "";
  }
};

export const getInputDate = function() {
  let d = new Date();
  var mm = doubleDigit(d.getMonth() + 1);
  var dd = doubleDigit(d.getDate());
  var yy = d.getFullYear();
  var myDateString = yy + "-" + mm + "-" + dd;
  return myDateString;
};

export const getReadableDate = function(date) {
  if (!date) return "-";
  const temp = new Date(date);
  const formatted = `${temp.getDate()} ${
    monthName[temp.getMonth()]
  } ${temp.getFullYear()}`;
  return formatted;
};

export const getDateID = function() {
  let d = new Date();
  var mm = doubleDigit(d.getMonth() + 1);
  var dd = doubleDigit(d.getDate());
  var yy = d.getFullYear();
  var myDateString = dd + "/" + mm + "/" + yy;
  return myDateString;
};

export const getAge = function(dateString) {
  var today = new Date();
  var birthDate = new Date(dateString);
  let ageText = "";
  var age = today.getFullYear() - birthDate.getFullYear();
  var m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
    if (m < 0) {
      m = 12 + m;
    } else {
      m = 11;
    }
  }
  if (!age && !m) {
    ageText += "0 tahun ";
  }
  if (age) {
    ageText += age + " tahun ";
  }
  if (m) {
    ageText += m + " bulan";
  }
  return ageText;
};

export const getDay = function(date) {
  // return date.getDay();
  let days = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"];
  let d = new Date(date);
  return days[d.getDay()];
};

export const getFullUrl = function(storageUrl, fileUrl) {
  //console.log(fileUrl);
  if (!fileUrl || !fileUrl.length) {
    return "";
  } else {
    if (fileUrl.indexOf("public/") > -1) {
      var urlArr = fileUrl.split("public/");
      fileUrl = storageUrl + urlArr[urlArr.length - 1];
    }
    //console.log(fileUrl);
    return fileUrl;
  }
};

export const getFileName = function(fileUrl) {
  if (!fileUrl || !fileUrl.length) {
    return "";
  } else {
    var urlArr = fileUrl.split("/");
    return urlArr[urlArr.length - 1];
  }
};

export const validateForms = function(formset, forms, self, create) {
  let validity = true;
  forms = forms.map(function(formOld) {
    const { form, valid } = validateForm(formset, formOld, self, create);
    validity = validity && valid;
    return form;
  });
  //console.log(forms);
  return { forms, validity };
};

export const validateForm = function(formset, form, self, create) {
  let valid = true;
  //console.log(formset);
  form = form.map(function(row) {
    row.columns = row.columns.map(function(column) {
      if (
        !column.optional &&
        column.type != "hidden" &&
        !formset[column.name]
      ) {
        valid = false;
        column.error = "Kolom ini wajib diisi";
      } else if (
        ["number", "money", "addon-right", "addon-left", "percentage"].indexOf(
          column.type
        ) > -1 &&
        !column.negativeValue &&
        parseInt(self.formSet[column.name]) < 0
      ) {
        valid = false;
        column.error = "Nilai yang diisi tidak boleh negatif";
      } else if (
        ["number", "money", "addon-right", "addon-left", "percentage"].indexOf(
          column.type
        ) > -1 &&
        column.max &&
        parseInt(self.formSet[column.name]) > column.max
      ) {
        valid = false;
        column.error = "Nilai yang diisi tidak boleh lebih dari " + column.max;
      } else {
        //console.log(column);
        if (column.regex) {
          //console.log(column.regex);
          //console.log("formset");
          //console.log(formset);
          //console.log("columnName");
          //console.log(column.name);
          if (String(formset[column.name] || "").match(column.regex)) {
            column.error = "";
          } else {
            column.error = column.regexError;
            valid = false;
          }
        } else {
          column.error = "";
        }
      }
      if (column.type == "file" || column.type == "image") {
        if (formset[column.name]) {
          if (
            create ||
            (!create && formset[column.name] != self[column.name + "_lama"])
          ) {
            //console.log("masuk: " + column.name);
            var reader = new FileReader();
            reader.onload = function(e) {
              column.value = e.target.result;
              column.thisValue = e.target.result;
            };
            // Cek ukuran file
            let size = formset[column.name].size;
            //console.log(size);
            // Jika pada input ditentukan size maksimal, gunakan size pada input, jika tidak, gunakan default max size 10MB
            let maxSize = column.maxSize ? parseInt(column.maxSize) : 10485760;
            if (size > maxSize) {
              valid = false;
              column.error = `Melebihi ukuran maksimal file ${convertSize(
                maxSize
              )}`;
            }
            reader.readAsDataURL(formset[column.name]);
          }
        }
      } else {
        column.value = formset[column.name];
      }
      return column;
    });
    return row;
  });

  // setTimeout(function() {
  //   // ////console.log('berhasil masuk ke awal sini');
  //   form.map((item) => {
  //     item.columns = item.columns.map((column) => {
  //       column.key = Math.random();
  //       return column;
  //     });
  //     return item;
  //   });
  //   // ////console.log('berhasil masuk ke akhir sini');
  // }, 2000);
  // form.splice(0, 1, form[0]);
  return { form, valid };
};
export const updateForms = function(formset, forms, create, handleChange) {
  forms = forms.map(function(formOld) {
    const form = updateForm(formset, formOld, create, handleChange);
    return form;
  });
  return { forms, formset };
};

export const updateForm = function(formset, form, create, handleChange) {
  //console.log(create);
  form = form.map(function(row) {
    //console.log("masuk ke updateForm dari reset");
    //console.log(row);
    //console.log(create);
    row.columns = row.columns.map(function(column) {
      // if(formset[column.name]){
      if (column.name == "no_kartu") {
        column.type = "hidden";
      }
      if (column.type == "select" && !formset[column.name]) {
        column.value = -1;
        delete column.error;
      } else {
        column.value = formset[column.name];
        //console.log(column.value);
        //console.log(column.name);
        // //console.log('-------dari resetForm Masuk ke sini');
        if (!column.value || column.value == -1) {
          delete column.error;
          // //console.log('------masuk ke tidak ada valuenya')
        }
      }
      // //console.log('----column.error');
      // //console.log(column.error);
      // //console.log('----column');
      // //console.log(column);

      if (create || (!create && ["file", "image"].indexOf(column.type) < 0)) {
        //console.log('masuk ke handleChange')
        handleChange(
          {
            target: {
              value: column.value,
              name: column.name,
              type: column.type,
            },
          },
          create
        );
      }
      // }
      return column;
    });
    return row;
  });
  //console.log('updateForm');
  //console.log({form,formset});
  //console.log('updateForm');

  return { form, formset };
};
export const resetForms = function(formset, forms, create, handleChange) {
  forms = forms.map(function(formOld) {
    let data = resetForm(formset, formOld, create, handleChange);
    let form = data.form;
    formset = data.formset;
    return form;
  });
  return { forms, formset };
};
export const resetForm = function(formset, form, create, handleChange) {
  Object.keys(formset).forEach(function(key) {
    if (
      [
        "tgl_periksa",
        "tgl_masuk",
        "tgl_tindakan",
        "jam_periksa",
        "jam_tindakan",
        "jam_masuk",
        "generate_form",
        "jumlah",
      ].indexOf(key) < 0
    ) {
      //console.log(key);
      formset[key] = "";
    }
  });
  // form.map((item) => {
  //   item.columns = item.columns.map((column) => {
  //     column.key = Math.random();
  //     return column;
  //   });
  //   return item;
  // });
  return updateResetForm(formset, form, create, handleChange);
};

export const updateResetForm = function(formset, form, create, handleChange) {
  //console.log(create);
  form = form.map(function(row) {
    //console.log("masuk ke updateResetForm dari reset");
    //console.log(row);
    //console.log(create);
    row.columns = row.columns.map(function(column) {
      column.key = Math.random();
      if (column.name == "no_kartu") {
        column.type = "hidden";
      }
      if (column.defaultValue) {
        //console.log("Before Update ==============");
        //console.log(column.value);
        //console.log(column);
        //console.log(column.defaultValue);
        console.log("masuk defaultValue");
        column.value = column.defaultValue;
        //console.log("After Update ==============");
        //console.log(column.value);
        //console.log(column);
        //console.log(column.defaultValue);
        //console.log("==============");

        delete column.error;
      } else {
        if (column.type == "select" && !formset[column.name]) {
          column.value = -1;
          delete column.error;
        } else {
          column.value = formset[column.name];
          if (!column.value || column.value == -1) {
            delete column.error;
          }
        }
      }

      if (create || (!create && ["file", "image"].indexOf(column.type) < 0)) {
        // //console.log("===handleChange====");
        // //console.log({
        //   value: column.value,
        //   name: column.name,
        //   type: column.type,
        // });
        // //console.log("===handleChange====");
        handleChange(
          {
            target: {
              value: column.value,
              name: column.name,
              type: column.type,
            },
            fromReset: true,
          },
          create
        );
      }
      return column;
    });
    return row;
  });
  return { form, formset };
};

export const incrementNumber = function(str) {
  let num = parseInt(str);
  return num + 1;
};

export const getFaskesName = async function(id) {
  if (!id) {
    return "Faskes tidak ditemukan";
  }
  //console.log(this.$store.state.HTTP);
  return "Faskes ditemukan";
};
export const formatNumber = function(num, digit) {
  let zeroLength = parseInt(digit) - String(num).length;
  num = parseInt(num);
  //console.log(zeroLength);
  let zeros = "";
  for (var i = 0; i < zeroLength; i++) {
    zeros += "0";
  }
  return zeros + String(num);
};

export const convertSize = function(num) {
  num = parseInt(num);
  if (num >= 1048576) {
    return `${(parseFloat(num) / 1048576.0).toFixed(2)} MB`;
  } else if (num >= 1024) {
    return `${(parseFloat(num) / 1024.0).toFixed(2)} KB`;
  } else {
    return `${num} Bytes`;
  }
};

export const ValidateCreditCardNumber = function(ccNum) {
  // var ccNum = document.getElementById("cardNum").value;
  var visaRegEx = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;
  var mastercardRegEx = /^(?:5[1-5][0-9]{14})$/;
  var amexpRegEx = /^(?:3[47][0-9]{13})$/;
  var discovRegEx = /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/;
  var isValid = false;
  if (visaRegEx.test(ccNum)) {
    isValid = true;
  } else if (mastercardRegEx.test(ccNum)) {
    isValid = true;
  } else if (amexpRegEx.test(ccNum)) {
    isValid = true;
  } else if (discovRegEx.test(ccNum)) {
    isValid = true;
  }

  if (isValid) {
    alert("Thank You!");
  } else {
    alert("Please provide a valid Visa number!");
  }
};

export const formatInputDate = function(date) {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return `${year}-${month
    .toString()
    .padStart(2, "0")}-${day.toString().padStart(2, "0")}`;
};

/*
updateForms(formset,forms,create,handleChange){
  let self=this;
  forms = forms.map(function(formOld){
    const form = self.updateForm(formset,formOld,create,handleChange);
    return form;
  });
  return {forms,formset};
},

updateForm(formset,form,create,handleChange){
  form = form.map(function(row) {
      row.columns = row.columns.map(function(column) {
      if(formset[column.name]){
          if(column.type=='select' && !formset[column.name]){
            column.value = -1;
            column.error='';
          }
          else{
            column.value = formset[column.name];
            if(!column.value){
              column.error='';
            }
          }
          if(create || (!create && ['file','image'].indexOf(column.type) < 0 )){
            handleChange({
                target:{
                    value:column.value,
                    name:column.name,
                    type:column.type
                }
            },create);
          }
      }
      return column;
      });
      return row;
  });
  return {form,formset};
},
resetForms(formset,forms,create,handleChange){
  let self=this;
  forms = forms.map(function(formOld){
    let data = self.resetForm(formset,formOld,create,handleChange);
    let form=data.form;
    formset=data.formset;
    return form;
  });
  return {forms,formset};
},
resetForm(formset,form,create,handleChange){
  Object.keys(formset).forEach(function(key){
    //console.log(key);
    formset[key]='';
  });
  return this.updateForm(formset,form,create,handleChange);
},*/

export const updateFilter = function(formset, form, create, handleChange) {
  //console.log(create);
  form.columns = form.columns.map(function(column) {
    // if(formset[column.name]){
    if (column.type == "select" && !formset[column.name]) {
      column.value = -1;
      delete column.error;
    } else {
      column.value = formset[column.name];
      //console.log(column.value);
      //console.log(column.name);
      if (!column.value) {
        delete column.error;
      }
    }
    if (create || (!create && ["file", "image"].indexOf(column.type) < 0)) {
      //console.log('masuk ke handleChange')
      handleChange(
        {
          target: {
            value: column.value,
            name: column.name,
            type: column.type,
          },
        },
        create
      );
    }
    // }
    return column;
  });
  //console.log('updateForm');
  //console.log({form,formset});
  //console.log('updateForm');

  return { form, formset };
};

export const toCapitalize = function(str) {
  const arr = str.split(" ");

  //loop through each element of the array and capitalize the first letter.

  for (var i = 0; i < arr.length; i++) {
    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1).toLowerCase();
  }

  //Join all the elements of the array back into a string
  //using a blankspace as a separator
  const str2 = arr.join(" ");
  return str2;
};

export const regexes = {
  phone: /^((?:[1-9][0-9 ().-]{5,28}[0-9])|(?:(00|0)( ){0,1}[1-9][0-9 ().-]{3,26}[0-9])|(?:(\+)( ){0,1}[1-9][0-9 ().-]{4,27}[0-9]))$/,
  KTP: /^(1[1-9]|21|[37][1-6]|5[1-3]|6[1-5]|[89][12])\d{2}\d{2}([04][1-9]|[1256][0-9]|[37][01])(0[1-9]|1[0-2])\d{2}\d{4}$/,
  SIM: /^[0-9]{12,16}$/,
  Paspor: /^[A-Z][0-9]{6,9}$/,
  BPJS: /^[0-9]{13}$/,
  tkn_darah: /^(29[0-9]|2[0-9][0-9]|[01]?[0-9][0-9]?)\/(29[0-9]|2[0-9][0-9]|[01]?[0-9][0-9]?)$/,
  // suhu:/^[0-9]{1,3}$/,
  suhu: "",
  nadi: /^[0-9]{1,3}$/,
  respirasi: /^[0-9]{1,3}$/,
  // berat:/^[0-9]{1,3}$/,
  berat: "",
  // tinggi:/^[0-9]{2,3}$/,
  tinggi: "",
  // gds:/^[0-9]{1,4}$/,
  gds: "",
  email: /^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*$/,
};

export const regexPlaceholders = {
  phone: "e.g : +6287783219008",
  KTP: "e.g : 1802061803030001",
  SIM: "e.g : 12209410000312",
  Paspor: "e.g : B1488640",
  BPJS: "e.g : 0000035257174",
  tkn_darah: "e.g : 120/80",
  suhu: "e.g : 36",
  nadi: "e.g : 75",
  respirasi: "e.g : 18",
  berat: "e.g : 75",
  tinggi: "e.g : 155",
  gds: "e.g : 190",
  email: "e.g : hello@idgw.co.id",
};

export const regexErrors = {
  phone: "Nomor Telepon yang dimasukkan tidak sesuai format",
  KTP: "Nomor KTP yang dimasukkan tidak sesuai format",
  SIM: "Nomor SIM yang dimasukkan tidak sesuai format",
  Paspor: "Nomor Paspor yang dimasukkan tidak sesuai format",
  BPJS: "Nomor BPJS yang dimasukkan tidak sesuai format (13 digit)",
  tkn_darah:
    "Tekanan darah yang dimasukkan tidak sesuai format (sistol/diastol)",
  suhu: "Suhu yang dimasukkan tidak sesuai format",
  nadi: "Nadi yang dimasukkan tidak sesuai format",
  respirasi: "Respirasi yang dimasukkan tidak sesuai format",
  berat: "Berat badan yang dimasukkan tidak sesuai format",
  tinggi: "Tinggi badan yang dimasukkan tidak sesuai format",
  gds: "Nilai GDS yang dimasukkan tidak sesuai format",
  email: "Email yang Anda masukkan tidak valid",
};

export const aturanPakai = [
  "3 x 1 @1sdm",
  "3 x 1 @1sdt",
  "3 x 1 @1kapsul",
  "2 x 1 @1sdm",
  "2 x 1 @1sdt",
  "2 x 1 @1kapsul",
  "1 x 1 @1sdm",
  "1 x 1 @1sdt",
  "1 x 1 @1kapsul",
];

export const aturanPakaiOptions = aturanPakai.map((item) => {
  return { value: item, label: item };
});

export const jenisObatOptions = [
  { label: "Obat Oral", value: "OBAT ORAL" },
  { label: "Obat Parenteral", value: "OBAT PARENTERAL" },
  { label: "Obat Topikal", value: "OBAT TOPIKAL" },
  { label: "Obat Injeksi", value: "OBAT INJEKSI" },
];

export const lokasiObatOptions = [
  { label: "Apotek", value: "Apotek" },
  { label: "Gudang", value: "Gudang" },
  { label: "Lab", value: "Lab" },
];

// export const golonganObat = [
//   'Obat Bebas Terbatas', 'Obat Bebas', 'Obat Keras', 'Obat Wajib Apotek (OWA)', 'Obat Golongan Narkotika', 'Obat Psikotropika', 'Obat Herbal'

// ]

export const golonganObat = [
  "Obat Generik Formularium",
  "Obat Generik Non Formularium",
  "Obat Non Generik Formularium",
  "Obat Non Generik Non Formularium",
];

export const golonganObatOptions = golonganObat.map((item) => {
  return { value: item, label: item };
});

export const jenisFaskes = ["Rumah Sakit", "Puskesmas", "Faskes Lain"];

export const jenisFaskesOptions = jenisFaskes.map((item) => {
  return { value: item, label: item };
});

export const tindakLanjutPenanganan = [
  "Dirawat",
  "Dirujuk",
  "Pulang",
  "Mati di UGD",
  "DOA",
];

export const tindakLanjutPenangananOptions = tindakLanjutPenanganan.map(
  (item) => {
    return { value: item, label: item };
  }
);

export const kategoriTindakan = ["Efektif", "Cito"];

export const kategoriTindakanOptions = kategoriTindakan.map((item) => {
  return { value: item, label: item };
});

export const jenisAnestesi = ["Umum", "Lokal"];

export const jenisAnestesiOptions = jenisAnestesi.map((item) => {
  return { value: item, label: item };
});

export const golonganTindakan = [
  "Canggih",
  "Khusus",
  "Besar",
  "Sedang",
  "Kecil",
];

export const golonganTindakanOptions = golonganTindakan.map((item) => {
  return { value: item, label: item };
});

export const ruangOperasi = [
  { nama: "Ruang Operasi 1", id: 1 },
  { nama: "Ruang Operasi 2", id: 2 },
  { nama: "Ruang Operasi 3", id: 3 },
  { nama: "Ruang Operasi 4", id: 4 },
];

export const ruangOperasiOptions = ruangOperasi.map((item) => {
  return { value: item.id, label: item.nama };
});

let ruangOperasiSimplified = {};
ruangOperasi.forEach((item) => {
  ruangOperasiSimplified[item.id] = item.nama;
});

export const getRuangOperasi = function(id) {
  return ruangOperasiSimplified[id];
};

export const snakeCaseToCapitalize = function(sentence) {
  if (sentence) {
    return sentence
      .replace(/_/g, " ")
      .split(" ")
      .map((word) => word[0].toUpperCase() + word.slice(1))
      .join(" ");
  }
  return sentence;
};
// export const getProvinceName = async function(id){
//   return 'RIAU';
// }

// export const getFullAddress = async function(strAddr,id_prov,id_kota,id_kecamatan,id_kelurahan){
//   //console.log('cek HTTP');
//   //console.log(await this.$store.state.HTTP);
//   //console.log('cek HTTP');

//   return 'RIAU';

// }
